/* RESPONSIBLE TEAM: team-knowledge-foundations */
import BaseAboutRoute from 'embercom/routes/base/about-route';

export default BaseAboutRoute.extend();
